export default "__VITE_ASSET__e3e78003__"